import { mediaImg } from '@/components/imageConstants';

export default function ResponsiveImage({ src, alt, sizes = '100vw', widths = [480, 800, 1200, 1600], width = 1600, height = 900, quality = 70, ...props }) {
  return <img
    src={src ? mediaImg(src, widths[widths.length - 1], quality) : undefined}
    srcSet={src ? widths.map(w => `${mediaImg(src, w, quality)} ${w}w`).join(', ') : undefined}
    sizes={sizes} width={width} height={height} alt={alt}
    loading="lazy" decoding="async" {...props}
  />;
}